import * as PropTypes from 'prop-types';
import { pointType } from './geometry';

export const eventShape = {
  clientPos: pointType.isRequired,
  pagePos: pointType.isRequired,
  svgPos: pointType.isRequired,
  type: PropTypes.oneOf(['mousedown', 'mouseup', 'mousemove', 'contextmenu']).isRequired,
  ctrlKey: PropTypes.bool.isRequired,
  altKey: PropTypes.bool.isRequired,
  shiftKey: PropTypes.bool.isRequired,
  metaKey: PropTypes.bool.isRequired,
};
